module.exports = __webpack_public_path__ + "media/media/values/olga-falko-1d2a7443ab1aae238a0803ef7723c3ba.jpg";